import React from 'react'
import {Card, CardBody, CardHeader, Col, FormGroup, Input, Modal, Table,} from "reactstrap";
import Button from "reactstrap/es/Button";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import dateHelpers from "../../helpers/DateHelper";
import ErrorModal from "../Alerts/ErrorModal";
import businessHelper from "../../helpers/BusinessHelper";
import CheckBoxList from "../Tables/CheckBoxList";
import paymentTypeHelpers from "../../helpers/PaymentTypeHelper";
import reportApiService from "../../api/report-api-service";
import IncomesAndExpenses from "./IncomesAndExpenses";
import constants from "../../shared/constants";
import EditIncomeView from "./EditIncomeView";
import categoryHelpers from "../../helpers/CategotyHelper";
import lsHelpers from "../../helpers/LsHelper";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

const propTypes = {};

export default class BudgetView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            period: this.setPeriod(),
            filters: {
                paymentMethods: null,
                categories: null,
            },
            expenseData: null,
            filteredExpenseData: null,
            incomeData: null,
            filteredIncomeData: null,
            incomeTotal: 0,
            filteredIncomeTotal: 0,
            expenseTotal: 0,
            filteredExpenseTotal: 0,
            type: constants.cabinet.incomes,
            validation: {
                start: true,
                end: true
            },
        };
    }

    onIncomeSelected = this.onIncomeSelected.bind(this);

    toggleFilters() {
        this.setState({showFilters: !this.state.showFilters});
    }

    componentDidMount() {
        this.getData()
    }

    setType(type) {
        this.setState({type: type})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.filters !== this.state.filters || prevState.period !== this.state.period) {
            this.handleValidation();
            this.setState({showSearchButton: true})
        }

    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-start":
                this.setState(prevState => ({
                    period: {
                        ...prevState.period,
                        start: newValue
                    }
                }));
                lsHelpers.setReportDateStart(newValue);
                break;
            case "input-end":
                this.setState(prevState => ({
                    period: {
                        ...prevState.period,
                        end: newValue
                    }
                }));
                lsHelpers.setReportDateEnd(newValue);
                break;
            default:
                return null;
        }
    }

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showFilters &&
                    this.renderFilterModal()
                    }

                    {this.state.showIncomeModal &&
                    this.renderIncomeModal()
                    }

                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    <Col lg="12">
                        <Card className="bg-default shadow">
                            <Row style={{marginLeft: 4}}>
                                <Col lg="3">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-start"
                                        >
                                            {commonStrings.from}
                                        </label>
                                        <Input
                                            className={this.state.validation.start === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={this.handleChange.bind(this)}
                                            defaultValue={this.state.period.start}
                                            id="input-start"
                                            type="date"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="3">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-end"
                                        >
                                            {commonStrings.until}
                                        </label>

                                        <Input
                                            className={this.state.validation.end === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={this.handleChange.bind(this)}
                                            defaultValue={this.state.period.end}
                                            id="input-end"
                                            type="date"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="auto" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <Row style={{marginTop: 4}}>
                                        <Col>
                                            <Button
                                                color={this.filtersAreEmpty() ? "info" : "danger"}
                                                onClick={this.prepareAndShowFilters.bind(this)}
                                                size="lg"
                                            >
                                                {reportStrings.filter}
                                            </Button>
                                        </Col>
                                        {this.state.showSearchButton &&
                                        <Col>
                                            <Button

                                                color={"success"}
                                                onClick={this.getData.bind(this)}
                                                size="lg"
                                            >
                                                {commonStrings.search}
                                            </Button>
                                        </Col>
                                        }
                                        <Col>
                                            <Button
                                                color="white"
                                                outline={true}
                                                onClick={e => this.clearSelectedAndShowIncomeModal(e)}
                                                size="lg"
                                            >
                                                <i className="fas fa-plus text-white mr-2"/>
                                                {this.state.type === constants.cabinet.incomes ? resourceStrings.cabinet.add_income : resourceStrings.cabinet.add_expense}
                                            </Button>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                            <Card className="bg-default shadow">
                                <CardHeader className="bg-transparent">
                                    <Row>
                                        <h2 className="text-white mb-0">{this.reportName()}</h2>

                                        <div style={{position: "absolute", right: 20, top: 10}}>


                                        </div>
                                    </Row>
                                    <Row>
                                        <h5 className="text-warning mb-0">{this.reportStats()}</h5>
                                    </Row>
                                </CardHeader>
                                {this.renderReport()}
                            </Card>
                        </Card>
                    </Col>
                </>
            </LoadingOverlay>
        )
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    reportName() {
        return resourceStrings.cabinet.incomes_and_expenses
    }

    reportStats() {
        return resourceStrings.cabinet.incomes + ": " + businessHelper.currency() + this.state.incomeTotal.toFixed(2)
            + ": " + resourceStrings.cabinet.expenses + ": " + businessHelper.currency() + this.state.expenseTotal.toFixed(2)
    }

    setPeriod() {
        lsHelpers.setReportDateEnd(dateHelpers.databaseDate(dateHelpers.lastDayOfMonth()));
        lsHelpers.setReportDateStart(dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()));

        return {
            start: dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()),
            end: dateHelpers.databaseDate(dateHelpers.lastDayOfMonth())
        };
    }

    getData() {
        if (this.datesAreValid()) {
            this.setState({isLoading: true, incomesExpensesData: null, incomeData: null, expenseData: null});

            reportApiService.incomesExpenses(this.state.period)
                .then(res => {
                    const incomes = this.filter(res.incomes);
                    const expenses = this.filter(res.expenses);

                    const incomeTotal = incomes.map(it => parseFloat(it.price) * it.qty).reduce((a, b) => a + b, 0);
                    const expenseTotal = expenses.map(it => parseFloat(it.price) * it.qty).reduce((a, b) => a + b, 0);

                    this.setState({
                        incomeData: incomes,
                        expenseData: expenses,
                        students: res.students,
                        partners: res.partners,
                        isLoading: false,
                        incomeTotal: incomeTotal,
                        expenseTotal: expenseTotal,
                        showSearchButton: false
                    });

                    this.renderReport()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    renderReport() {
        if (this.state.incomeData !== null && this.state.expenseData !== null) {
            return <IncomesAndExpenses
                type={this.state.type}
                incomeData={this.state.incomeData}
                expenseData={this.state.expenseData}
                closeReport={this.closeReport}
                setType={this.setType.bind(this)}
                onIncomeSelected={this.onIncomeSelected}
            />;
        }
    }

    onIncomeSelected(income) {
        this.setState({selectedIncome: income, showIncomeModal: true})
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    handleValidation() {
        this.validateDates();
    }

    validateDates() {
        const start = new Date(this.state.period.start);
        const end = new Date(this.state.period.end);

        if (dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)) {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: start <= end,
                    end: start <= end,
                }
            }));
        } else {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: dateHelpers.isValidDate(start),
                    end: dateHelpers.isValidDate(end),
                }
            }));
        }
    }

    datesAreValid() {
        const start = new Date(this.state.period.start);
        const end = new Date(this.state.period.end);

        if (dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)) {
            return start <= end
        } else {
            return dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)
        }
    }

    renderFilterModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showFilters}
                toggle={() => this.toggleFilters("formModal")}
            >
                <div className="modal-body p-0">

                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-gradient-secondary pb-2">
                            <div className="text-white text-center mt-2 mb-3">
                                <h4>{reportStrings.filter}</h4>
                            </div>
                        </CardHeader>
                        {this.renderFilters()}
                    </Card>
                </div>
            </Modal>
        )
    }

    prepareAndShowFilters() {
        this.toggleFilters();
    }

    renderPTTable() {
        const selected = (this.state.filters.paymentMethods) ? this.state.filters.paymentMethods.map(it => it.value) : [];
        return (paymentTypeHelpers.paymentTypes()).map((pm, index) => {

            return (
                <CheckBoxList item={{id: pm.value, label: pm.label}} key={pm.value}
                              selected={selected.includes(pm.value)}
                              handleChange={this.handlePMSelected.bind(this)}/>
            )
        })
    }

    renderCategoryTable() {
        const selected = (this.state.filters.categories) ? this.state.filters.categories.map(it => it.value) : [];
        return (categoryHelpers.categories()).map((pm, index) => {

            return (
                <CheckBoxList item={{id: pm.value, label: pm.label}} key={pm.value}
                              selected={selected.includes(pm.value)}
                              handleChange={this.handleCategorySelected.bind(this)}/>
            )
        })
    }

    handleCategorySelected(checked, value) {
        const pm = categoryHelpers.categories().find(it => it.value === value);
        const selected = ((this.state.filters.categories) ? this.state.filters.categories : []);
        const selectedValues = ((this.state.filters.categories) ? this.state.filters.categories : []).map(it => it.value);

        if (pm) {
            if (checked) {
                if (!selectedValues.includes(pm.value)) {
                    selected.push(pm);
                }
            } else {
                if (selectedValues.includes(pm.value)) {
                    const index = selectedValues.indexOf(pm.value);
                    if (index !== -1) selected.splice(index, 1);
                }
            }

            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    categories: selected
                }
            }));
        }
    }

    handlePMSelected(checked, value) {
        const pm = paymentTypeHelpers.paymentTypes().find(it => it.value === value);
        const selected = ((this.state.filters.paymentMethods) ? this.state.filters.paymentMethods : []);
        const selectedValues = ((this.state.filters.paymentMethods) ? this.state.filters.paymentMethods : []).map(it => it.value);

        if (pm) {
            if (checked) {
                if (!selectedValues.includes(pm.value)) {
                    selected.push(pm);
                }
            } else {
                if (selectedValues.includes(pm.value)) {
                    const index = selectedValues.indexOf(pm.value);
                    if (index !== -1) selected.splice(index, 1);
                }
            }

            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    paymentMethods: selected
                }
            }));
        }
    }

    filtersAreEmpty() {
        return (!this.state.filters.ticketTypes || this.state.filters.ticketTypes.length === 0)
            && (!this.state.filters.paymentMethods || this.state.filters.paymentMethods.length === 0)
            && (!this.state.filters.teachers || this.state.filters.teachers.length === 0)
            && (!this.state.filters.rooms || this.state.filters.rooms.length === 0)
    }

    renderFilters() {
        return <Row>
            <Col lg="6">
                <Card style={{margin: 10}}>
                    <Table
                        className="align-items-center table-light table-flush mt-2"
                        responsive
                    >
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">{resourceStrings.cabinet.categories}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderCategoryTable()}
                        </tbody>
                    </Table>
                </Card>
            </Col>
            <Col lg="6">
                <Card style={{margin: 10}}>
                    <Table
                        className="align-items-center table-light table-flush mt-2"
                        responsive
                    >
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">{resourceStrings.payment_methods.payment_methods}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderPTTable()}
                        </tbody>
                    </Table>
                </Card>
            </Col>
        </Row>
    }

    toggleIncomeModal = state => {
        this.setState({
            showIncomeModal: !this.state.showIncomeModal
        });
    };

    closeEditIncomeView(e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({showIncomeModal: false, selectedIncome: null});
        this.getData();
    }

    renderIncomeModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showIncomeModal}
                toggle={() => this.toggleIncomeModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{this.state.type === constants.cabinet.incomes ? resourceStrings.cabinet.add_income : resourceStrings.cabinet.add_expense}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <EditIncomeView
                                closeEditIncomeView={this.closeEditIncomeView.bind(this)}
                                modal={true}
                                income={this.state.selectedIncome}
                                partner={this.findPartner()}
                                deleteIncome={this.deleteIncome.bind(this)}
                                updateIncome={this.updateIncome.bind(this)}
                                type={this.state.type}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    deleteIncome(e, income) {
        e.preventDefault();

        if (this.state.type === constants.cabinet.incomes) {
            this.removeIncome(income);
        } else this.removeExpense(income);
    }

    updateIncome(e, income, partner, saveInvoice) {
        e.preventDefault();
        if (partner) {
            income.partner_name = partner.name;
            income.partner_id = partner.id;
            income.partner_address = partner.address;
            income.partner_dni = partner.dni;
            income.partner_email = partner.email;
            income.partner_type = !partner.id ? "p" : partner.type;
        }

        if (this.state.type === constants.cabinet.incomes) {
            this.saveIncome(income, saveInvoice);
        } else this.saveExpense(income, saveInvoice);
    }

    saveExpense(expense, saveInvoice) {
        if (expense.id) {
            reportApiService.updateExpense(expense, saveInvoice)
                .then(res => {
                    this.getData();
                    this.closeEditIncomeView()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        } else {
            expense.partner_type = "p";
            reportApiService.postExpense(expense, saveInvoice)
                .then(res => {
                    this.getData();
                    this.closeEditIncomeView()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    saveIncome(income, saveInvoice) {
        if (income.id) {
            reportApiService.updateIncome(income, saveInvoice)
                .then(res => {
                    this.getData();
                    this.closeEditIncomeView()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        } else {
            reportApiService.postIncome(income, saveInvoice)
                .then(res => {
                    this.getData();
                    this.closeEditIncomeView()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    removeIncome(income) {
        if (income.id) {
            reportApiService.deleteIncome(income.id)
                .then(res => {
                    this.getData();
                    this.closeEditIncomeView()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    removeExpense(expense) {
        if (expense.id) {
            reportApiService.deleteExpense(expense.id)
                .then(res => {
                    this.getData();
                    this.closeEditIncomeView()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    filter(list) {
        let i = list;
        const filters = this.state.filters;

        if (filters.paymentMethods && filters.paymentMethods.length > 0) {
            i = i.filter(it => filters.paymentMethods.map(c => c.value).includes(it.pt));
        }

        if (filters.categories && filters.categories.length > 0) {
            i = i.filter(it => filters.categories.map(c => c.value).includes(it.category));
        }

        return i
    }

    findPartner() {
        if (this.state.selectedIncome && (this.state.selectedIncome.student_id || this.state.selectedIncome.partner_id)) {
            if (this.state.selectedIncome.partner_id) {
                return (this.state.partners || []).find((p) => {return p.id == this.state.selectedIncome.partner_id})
            }
            else if (this.state.selectedIncome.student_id) {
                return (this.state.students || []).find((p) => {return p.id == this.state.selectedIncome.student_id})
            }
        }
        else return null
    }

    clearSelectedAndShowIncomeModal(e) {
        e.preventDefault();
        this.setState({selectedIncome: null, showIncomeModal: !this.state.showIncomeModal});
    }
}

BudgetView.propTypes = propTypes;